import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { DatePipe, NgOptimizedImage } from '@angular/common';
import {
  getColumnKey,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import {
  BoxQuestionnaireStatus,
  BoxQuestionnaireStatusComponent,
  PublicBoxQuestionnaireCollectionFilter,
  PublicBoxQuestionnaireCollectionItem,
} from '@web/shared/module/shop';
import { isNotNil } from '@web/utils';
import {
  Route,
  RouteParam,
  RouteQueryParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-public-box-questionnaire-list-custom-cell-template',
  imports: [
    BoxQuestionnaireStatusComponent,
    DatePipe,
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    RouterLinkComponent,
    TableBodyNoReferenceCellComponent,
    Tooltip,
  ],
  templateUrl:
    './public-box-questionnaire-list-custom-cell-template.component.html',
  styleUrl:
    './public-box-questionnaire-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxQuestionnaireListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<PublicBoxQuestionnaireCollectionItem, PublicBoxQuestionnaireCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<PublicBoxQuestionnaireCollectionItem>();

  protected readonly BoxQuestionnaireStatus = BoxQuestionnaireStatus;
  protected readonly detailsParams = this.detailsParamsSignal();
  protected readonly questionnaireDetailsParams =
    this.questionnaireDetailsParamsSignal();
  protected readonly previewQueryParams = {
    [RouteQueryParam.Mode]: 'preview',
  };
  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<PublicBoxQuestionnaireCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly Route = Route;

  private detailsParamsSignal(): Signal<RouterLinkParams> {
    return computed(() => ({
      [RouteParam.Number]: this.model().orderNumber,
    }));
  }

  private questionnaireDetailsParamsSignal(): Signal<RouterLinkParams> {
    return computed(() => ({
      [RouteParam.Guid]: this.model().id,
    }));
  }
}
